import { useMutation } from '@apollo/client';
import { Button, Col, Modal, Row } from 'antd';
import { upperCase } from 'lodash';

import { UPDATE_USER } from './graphql/Mutations';

function ActivateDeactivateModal({
  isModalOpen,
  setIsModalOpen,
  refetch,
  selectedRecord,
  setSelectedRecord,
}) {
  const [updateUser, { loading }] = useMutation(UPDATE_USER, {
    onCompleted() {
      setIsModalOpen(false);
      setSelectedRecord();
      refetch();
    },
    onError(e) {
      // eslint-disable-next-line no-console
      console.log(e);
    },
  });

  const handleSubmit = () => {
    updateUser({
      variables: {
        input: {
          isActive: !selectedRecord?.isActive,
        },
        where: {
          id: selectedRecord?.id,
        },
      },
    });
  };
  return (
    <div id="change-status-modal">
      <Modal
        centered
        closable={false}
        title={
          <h3 className="m-0 mb-10">
            {upperCase(
              `${selectedRecord?.isActive ? 'Deactivate' : 'Activate'} User`,
            )}
          </h3>
        }
        footer={null}
        onCancel={() => setIsModalOpen(false)}
        open={isModalOpen}
        width={576}
        maskClosable={false}
      >
        <p className="mb-16 mt-10">
          Are you sure you want to{' '}
          {selectedRecord?.isActive ? 'deactivate' : 'activate'} User?
        </p>
        <Row gutter={10}>
          <Col span={12}>
            <Button
              disabled={loading}
              onClick={() => {
                setIsModalOpen(false);
                setSelectedRecord();
              }}
              className="full-width font-600 submit-btn"
            >
              Cancel
            </Button>
          </Col>
          <Col span={12}>
            <Button
              type="primary"
              htmlType="submit"
              disabled={loading}
              className="full-width font-600 submit-btn"
              loading={loading}
              onClick={() => handleSubmit()}
            >
              {selectedRecord?.isActive ? 'Deactivate' : 'Activate'}
            </Button>
          </Col>
        </Row>
      </Modal>
    </div>
  );
}

export default ActivateDeactivateModal;
